import { toast } from 'sonner'

// One prompt per page life, shared by every caller. Two of them race after a
// deploy: the version poll (useVersionCheck) and the first stale chunk that
// fails to import (lazyWithReload). They ask for the same single action, so a
// second toast only stacks an identical, never-dismissing card on the first.
let hasPrompted = false

/**
 * Offers the only fix for a stale build: discard it and fetch the new one.
 *
 * Not navigation, so useNavigate does not apply — the point is to drop this
 * document, not to move within it.
 */
export function promptReload(description: string): void {
  if (hasPrompted) return
  hasPrompted = true
  toast('New version available!', {
    description,
    action: { label: 'Reload', onClick: () => window.location.reload() },
    duration: Infinity, // Never auto-dismiss.
    closeButton: false, // No dismiss button, so the offer stays visible.
  })
}
